<!-- git/truth-first-look/src/components/dashboard/PostComposer.tsx -->
<div class="bg-card border-b border-border px-4 pt-4 pb-3">
  <div class="flex gap-3">
    <div class="w-10 h-10 rounded-full bg-muted overflow-hidden flex-shrink-0 mt-1">
      <img [src]="avatarUrl" alt="" class="w-full h-full object-cover" />
    </div>

    <div class="flex-1 min-w-0">
      <textarea
        [(ngModel)]="text"
        rows="2"
        class="w-full bg-transparent text-foreground text-[15px] leading-relaxed placeholder:text-muted-foreground/60 resize-none outline-none py-2"
        placeholder="What's on your mind?"></textarea>

      <button type="button" class="flex items-center gap-1.5 text-ts-blue text-[13px] font-medium hover:bg-ts-blue/10 rounded-full px-2.5 py-1 -ml-2.5 transition-colors mb-2">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" class="text-ts-blue" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
        Everyone can reply
      </button>

      <div class="h-px bg-border -mx-1 mb-2"></div>

      <div class="flex items-center justify-between">
        <div class="flex items-center gap-0.5 -ml-2">
          <button *ngFor="let a of toolbarActions" type="button" [title]="a.label" class="p-2 rounded-full text-ts-blue hover:bg-ts-blue/10 transition-colors">
            <ng-container [ngSwitch]="a.icon">
              <svg *ngSwitchCase="'image'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              <svg *ngSwitchCase="'video'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="23 7 16 12 23 17 23 7" />
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
              </svg>
              <svg *ngSwitchCase="'emoji'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                <line x1="9" y1="9" x2="9.01" y2="9" />
                <line x1="15" y1="9" x2="15.01" y2="9" />
              </svg>
              <svg *ngSwitchCase="'calendar'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </ng-container>
          </button>
        </div>

        <button
          type="button"
          [disabled]="!text.trim()"
          class="h-9 px-5 rounded-full bg-ts-blue text-white text-sm font-semibold transition-all hover:brightness-110 active:scale-[0.97] disabled:opacity-40 disabled:cursor-not-allowed">
          Post
        </button>
      </div>
    </div>
  </div>
</div>
